<template>
    <div class="MsgWrap">
        <div class="info">
        </div>
        <div class="msgbody">

            <div class="write_wrap">
                <div class="receive_area">
                    <input type="text" placeholder="받을 닉네임"
                        v-model="receive_user_nic.val"
                        :class="{'validate':!receive_user_nic.isValid}"
                        @blur="clearValidity('receive_user_nic')"
                    >
                </div>
                <div>

                </div>
                <div class="input_area">
                    <input type="text"  placeholder="내용"
                        v-model="message.val"
                        :class="{'validate':!message.isValid}"
                        @blur="clearValidity('message')" @keyup.enter="sendMessage()"
                        maxlength="100"
                        >
                </div>
                <div class="btn_area">
                    <base-button @click="sendMessage()">쪽지보내기</base-button>
                </div>
            </div>
             <div class="notValid" v-if="!msgValid">
                받는 유저의 닉네임과 내용을 입력해 주세요
            </div>
        </div>
        <div class="info2">
            <div class="cont">* 보유포인트<span class="point">0</span></div>
            <div class="cont">* 쪽지이용료 1건당<span class="point">200</span> 포인트</div>
        </div>
         <div class="info3">
            친구목록에서 닉네임을 직접 선택 할수 있습니다.
            <base-button-sm mode="btn-white" >
                친구목록보기
            </base-button-sm>

        </div>
    </div>
</template>
<script>
import { auth } from '@/components/mixins/auth.js';
import { mapGetters } from 'vuex';
import io from "socket.io-client";
export default {
    name:'message'
    ,
    props:['userNic'],
    data(){
        return{
            receive_user_nic:{val:'',isValid:true},
            message:{val:'',isValid:true},
            msgValid:true,
            myMsg:'',
            isLoading:true,
            isLoadMore:false,
            page:1,
            lastPage:1,
            moreData:true,
            socket: io(this.$store.state.serverDomain + ":3000"),
        }
    },
    mixins:[ auth ],
    mounted(){
        this.listen();
        if(this.userNic)
        {
            this.receive_user_nic.val = this.userNic;
        }
    },
    computed:mapGetters({
        messageLists:'message/getMessages'
    }),
    methods:{
        reqDel(msgId){
            if(confirm('쪽지를 삭제 하시겠습니까?'))
            {
                this.delMessag(msgId);
                return;
            }else{
                return;
            }
        },
        async ckMsgItem($event)
        {
            //아이템 유무 확인 있으면 사용유무를 묻고 없으면 구매유무를 확인한다.
            const ckitem =  await this.ckItem('send_msg','pop','','쪽지 이용권');
            if(!ckitem){
                return;
            }else{
                //아이템이 있을시
                if($event.target.readOnly === true)
                {
                    $event.target.readOnly = false;
                    $event.target.style.background = "#fff";
                    // if(confirm('닉네임 변경은 아이템이 필요합니다.\n아이템을 사용하시겠습니까?'))
                    // {
                    //     $event.target.readOnly = false;
                    //     $event.target.style.background = "#fff";
                    // }
                }
            }
        },
        async delMessag(msgId)
        {

            try {
                const response = await this.$store.dispatch("message/deleteMessage", {message_id:msgId})
                console.log(response);
                // if(response.itemBuy)
                // {
                //     this.$store.commit('updateUserPoint',response.user);
                // }
                this.$flashMessage.show({
                    type: response.state_code===201?"info":"error",
                    title: response.message,
                    message: response.message,
                });
            }catch(error){
                console.log(error);
            }
        },
        setReceiveUser(nic)
        {
            this.receive_user_nic.val = nic;
            this.receive_user_nic.isValid = true;
        },
        listen() {
            this.socket.on("receiveMessage", (receive) => {
                console.log("쪽지가 발송 됨",receive);
                if(receive.toNic === this.user.nic)
                {
                    this.page=1;
                    this.getMessages();
                }
            });
        },
        scrollData(e)
        {
            //console.log(e)
            //console.log(e.target.scrollTop);
            if(e.target.scrollHeight - e.target.clientHeight <= e.target.scrollTop)
            {
                this.page = this.page+1;
                //다음페이지 로딩
                //마지막 페이지이면 더이상 데이터가 없습니다.
                if(this.lastPage < this.page)
                {
                    //alert('더이상 데이터가 없습니다.');
                    //this.moreData = false;
                    //alert();
                    return;
                }
                this.isLoadMore = true;

                this.getMessages();
            }
        },
        clearValidity(input) {
            this[input].isValid = true;
            this.validateMsg();
        },
        validateMsg()
        {
            this.msgValid = true;
            if (this.receive_user_nic.val === "" )
            {
                this.receive_user_nic.isValid = false;
                this.msgValid = false;
            }
            if (this.message.val === "") {
                this.message.isValid = false;
                this.msgValid = false;
            }

        },
        initMsgForm()
        {
            this.message.val = "";
            this.receive_user_nic.val ="";
        },
        async sendMessage()
        {
            this.validateMsg();
            if (!this.msgValid) {
                return;
            }
            const formData = {
                send_user_id:this.user.id,
                receive_user_nic:this.receive_user_nic.val,
                message:this.message.val,
            }
            this.moreData = true;
            try {
                const response = await this.$store.dispatch("message/sendMessage", formData)
                console.log('메세지 전송 response',response);
                // if(response.itemBuy)
                // {
                //     this.$store.commit('updateUserPoint',response.user);
                // }

                this.$flashMessage.show({
                    type: response.state_code===201?"info":"error",
                    title: response.message,
                    message: response.message,
                });
                if(response.state_code===201)
                {
                    this.socketIO_sendMessage();
                    this.initMsgForm();

                }
                //유저 정보 업데이트
                //console.log(response.user);
                this.$store.commit('updateUserPoint',response.user);
                //console.log(opener)
                //this.$root.updateUserInfo(response.user)
                // opener.location.reload()
                // window.location.reload()
            }catch(error){
                console.log(error);
            }
        },
        socketIO_sendMessage()
        {
            let params = {
                fromNic:this.user.nic,
                toNic:this.receive_user_nic.val,
            };
            this.socket.emit("sendMessage", params);
        }
    }
}
</script>
<style lang="scss" scoped>
.MsgWrap{
    .info{height:30px;}
    .msgbody{

        background: #edf2f7;
        display: flex;
        flex: 1 1 auto;
        flex-direction: column;
        //height:100vh;
        padding:1rem;
        .notValid{
            color:red;
            text-align:center;
        }
        .write_wrap{
            width: 100%;
            padding-left: 1rem;
            padding-right: 1rem;
            height: 4rem;
            display: flex;
            align-items: center;
            flex-direction: row;
            border-radius: .75rem;
            background-color: #fff;
            box-shadow: 0 1px 3px 0 rgba(0,0,0,.3);
            background:#eee;
            input{
                padding-left: 1rem;
                height: 2.5rem;
                display: flex;
                border-width: 1px;
                border-radius: .75rem;
                overflow: visible;
                border:1px solid #e2e8f0;
                width:100%;
                }
            .receive_area{
                width:20%;
                input{

                }
            }
            .validate{
                border:1px solid red;
            }
            .input_area{
                margin-left:1rem;
                width:60%;

            }
            .btn_area{
                margin-left: 1rem;
            }
        }

    }
    .info3{
        text-align:center;

        padding:10px 0;
    }
    .info2{
        display:flex;
        justify-content:center;
        background:#bfc4e3;
        .cont{
            padding:10px 10px;
            .point{
                font-weight:bold;
                color:#eb1250;
                display:inline-block;
                padding-left:10px;
            }
        }
    }
}
</style>
